import React from "react";
import { Typography, Box } from "@mui/material";
import markaazLogoPartners from "assets/logos/markaazForPartners.svg";
import toolsIcon from "assets/logos/toolsIcon.svg";

const sx = {
  root: {
    backgroundColor: "darkBlue.c100",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    width: "350px",
    padding: "0px 60px 0px 60px"
  },
  infoText: {
    width: "350px",
    color: "common.white",
    borderBottom: (theme) => `1px solid ${theme.palette.lightBlue.c100}`
  },
  detail: {
    width: "350px",
    color: "common.white",
    li: {
      marginBottom: "10px"
    }
  },
  iconStyle: {
    display: "flex",
    justifyContent: "center",
    height: "250px"
  },
  imgStyle: {
    width: "190px",
    paddingTop: "60px"
  }
};

const items = [
  "Your API key and Partner Id",
  "API configuration parameters",
  "Our Business Monitoring services, including your customer file upload and monitoring reports"
];

const accessItems = (
  <ul>
    {items.map((val) => (
      <li key={val}>
        <Typography variant="body1M">{val}</Typography>
      </li>
    ))}
  </ul>
);

const AuthLayout = () => {
  return (
    <Box sx={sx.root}>
      <Box sx={sx.imgStyle}>
        <img src={markaazLogoPartners} alt="Markaaz For Partners" />
      </Box>
      <Box sx={sx.infoText}>
        <Typography variant="h5" marginBottom="40px">
          Welcome to the Markaaz Enterprise Portal, your gateway to our Enterprise Services.
        </Typography>
      </Box>
      <Box sx={sx.detail}>
        <Typography variant="h6">Create your account to access:</Typography>
        {accessItems}
      </Box>
      <Box sx={sx.iconStyle}>
        <img src={toolsIcon} alt="Markaaz Tools Icon" />
      </Box>
    </Box>
  );
};

export default AuthLayout;
